import { useEffect } from "react";
import { toast } from "sonner";

import { onForegroundMessage } from "integrations/firebase/messaging";

/**
 * Foreground pushes as toasts. FCM suppresses the system notification while a
 * page of the site is visible, so without this a push sent to someone actively
 * using the app would vanish — the inbox bell still records it, but the moment
 * is the point of a push. Renders nothing; safe wherever push is unsupported
 * (the subscription resolves to a no-op).
 */
export function ForegroundPushToasts() {
  useEffect(() => {
    let unsubscribe: (() => void) | undefined;
    let cancelled = false;
    void onForegroundMessage(({ title, body }) => {
      if (title) toast(title, { description: body });
    })
      .then((cleanup) => {
        if (cancelled) cleanup();
        else unsubscribe = cleanup;
      })
      .catch(() => undefined);
    return () => {
      cancelled = true;
      unsubscribe?.();
    };
  }, []);
  return null;
}
